// extracted by mini-css-extract-plugin
export default {"TableView":"SalesTable_TableView__if0Kh","Cell":"SalesTable_Cell__zQNcm","Paper":"SalesTable_Paper__oUFdh"};